
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Network } from '@/types';

@Component
export default class SelectNetworkDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  loading = false

  selectedNetwork: Network | null = null

  created() {
    console.log('SelectNetworkDialog: created()'); // eslint-disable-line no-console
  }

  @Watch('value')
  onValueChange(val: boolean) {
    if (val === true) {
      this.selectedNetwork = null;
    }

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get networks(): Network[] {
    return this.$store.getters.networks;
  }

  get networkOptions() {
    return this.networks
      .map((n) => ({ value: n.shortname, text: n.name }));
  }

  onCancel() {
    this.dialog = false;
  }

  async onConfirm() {
    this.loading = true;

    this.$emit('select', this.selectedNetwork);

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
